import { Controller } from "@hotwired/stimulus"

interface DeviceInfo {
  userAgent: string
  platform: string
  language: string
  deviceType: 'Mobile' | 'Tablet' | 'Desktop'
  operatingSystem: string
  browser: string
  screenResolution: string
  viewportSize: string
  pixelRatio: number
  touchSupport: boolean
}

export default class extends Controller {
  static targets = ["currentUrlField", "deviceInfoField"]

  declare readonly currentUrlFieldTarget: HTMLInputElement
  declare readonly deviceInfoFieldTarget: HTMLInputElement

  connect() {
    this.captureCurrentUrl()
    this.captureDeviceInfo()
  }

  private captureCurrentUrl() {
    this.currentUrlFieldTarget.value = window.location.href
  }

  private captureDeviceInfo() {
    const deviceInfo = this.getDeviceInfo()
    this.deviceInfoFieldTarget.value = JSON.stringify(deviceInfo)
  }

  private getDeviceInfo(): DeviceInfo {
    const userAgent = navigator.userAgent
    const platform = navigator.platform
    const language = navigator.language
    const screen = window.screen
    const viewport = {
      width: window.innerWidth,
      height: window.innerHeight
    }

    // Detect device type
    const isMobile = /Mobi|Android/i.test(userAgent)
    const isTablet = /Tablet|iPad/i.test(userAgent)
    const deviceType: 'Mobile' | 'Tablet' | 'Desktop' = isMobile ? 'Mobile' : (isTablet ? 'Tablet' : 'Desktop')

    // Detect OS
    let operatingSystem = 'Unknown'
    if (/Windows/i.test(userAgent)) operatingSystem = 'Windows'
    else if (/Mac/i.test(userAgent)) operatingSystem = 'macOS'
    else if (/Linux/i.test(userAgent)) operatingSystem = 'Linux'
    else if (/Android/i.test(userAgent)) operatingSystem = 'Android'
    else if (/iPhone|iPad|iPod/i.test(userAgent)) operatingSystem = 'iOS'

    // Detect browser
    let browser = 'Unknown'
    if (/Chrome/i.test(userAgent) && !/Edge/i.test(userAgent)) browser = 'Chrome'
    else if (/Firefox/i.test(userAgent)) browser = 'Firefox'
    else if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) browser = 'Safari'
    else if (/Edge/i.test(userAgent)) browser = 'Edge'

    return {
      userAgent,
      platform,
      language,
      deviceType,
      operatingSystem: operatingSystem,
      browser,
      screenResolution: `${screen.width}x${screen.height}`,
      viewportSize: `${viewport.width}x${viewport.height}`,
      pixelRatio: window.devicePixelRatio || 1,
      touchSupport: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
    }
  }
}
